module.exports = __webpack_public_path__ + "static/media/69.7d647fc5.png";